@if (workPermits === null || workPermits?.length === 0) {
  <div class="info-card-empty">
    <i class="fa fa-inbox info-card-empty__icon"></i>
    <span>{{ 'GENERAL.no_data' | translate }}</span>
  </div>
}

@if (workPermits?.length > 0) {
  <div class="permit-cards">
    @for (workpermit of workPermits; track workpermit) {
      <div class="permit-card" [class.permit-card--expired]="isExpired(workpermit.endDate)">
        <div class="permit-card__status">
          @if (isExpired(workpermit.endDate)) {
            <span class="permit-status permit-status--expired">
              <i class="fa fa-exclamation-circle"></i>
              {{ 'PERSONAL_DATA.PERMITS.expired' | translate }}
            </span>
          } @else {
            <span class="permit-status permit-status--valid">
              <i class="fa fa-check-circle"></i>
              {{ 'PERSONAL_DATA.PERMITS.valid' | translate }}
            </span>
          }
        </div>
        <div class="permit-card__content">
          <div class="permit-card__row">
            @if (getTranslatedData(workpermit?.workPermitType)) {
              <div class="permit-card__item">
                <span class="permit-card__label">{{ 'PERSONAL_DATA.PERMITS.type' | translate }} : </span>
                <span class="permit-card__value">{{ getTranslatedData(workpermit?.workPermitType) }}</span>
              </div>
            }
            @if (workpermit?.workPermitId) {
              <div class="permit-card__item">
                <span class="permit-card__label">{{ 'PERSONAL_DATA.PERMITS.number' | translate }} : </span>
                <span class="permit-card__value permit-card__value--id">{{ workpermit?.workPermitId }}</span>
              </div>
            }
          </div>
          <div class="permit-card__row">
            @if (workpermit?.startDate) {
              <div class="permit-card__item">
                <span class="permit-card__label">{{ 'PERSONAL_DATA.PERMITS.startdate' | translate }} : </span>
                <span class="permit-card__value">{{ workpermit?.startDate | date:'dd/MM/yyyy' }}</span>
              </div>
            }
            @if (workpermit?.endDate) {
              <div class="permit-card__item">
                <span class="permit-card__label">{{ 'PERSONAL_DATA.PERMITS.enddate' | translate }} : </span>
                <span class="permit-card__value" [class.permit-card__value--warning]="isExpired(workpermit.endDate)">
                  {{ (workpermit?.endDate | date:'dd/MM/yyyy' | unlimitedDate) | translate }}
                </span>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
